import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";

const STATUS_COLORS = {
  NEW: "bg-alta/10 text-alta",
  CONTACTED: "bg-mustard/15 text-mustard",
  DISCUSSING: "bg-bindigo/10 text-bindigo",
  CONFIRMED: "bg-forest/10 text-forest",
  COMPLETED: "bg-ink/10 text-ink",
  DECLINED: "bg-ink/5 text-ink/40",
};

export default function Dashboard() {
  const [stats, setStats] = useState(null);
  const [recent, setRecent] = useState([]);

  useEffect(() => {
    api.get("/admin/stats").then((r) => setStats(r.data)).catch(() => {});
    api.get("/admin/enquiries").then((r) => setRecent(r.data.slice(0, 5))).catch(() => {});
  }, []);

  const cards = [
    { label: "Collections", value: stats?.collections, to: "/admin/collections" },
    { label: "Artworks", value: stats?.artworks, to: "/admin/folk-art" },
    { label: "Journal Stories", value: stats?.articles, to: "/admin/journal" },
    { label: "Enquiries", value: stats?.enquiries, to: "/admin/enquiries" },
    { label: "New Enquiries", value: stats?.new_enquiries, to: "/admin/enquiries", accent: true },
  ];

  return (
    <div data-testid="admin-dashboard">
      <h1 className="font-serif text-4xl font-light text-ink">Studio Dashboard</h1>
      <p className="mt-2 text-sm font-light text-ink/55">Everything Ipsita's site is carrying, at a glance.</p>

      <div className="mt-10 grid grid-cols-2 lg:grid-cols-5 gap-4">
        {cards.map((c) => (
          <Link
            key={c.label}
            to={c.to}
            data-testid={`stat-${c.label.toLowerCase().replace(/\s+/g, "-")}`}
            className={`p-6 border transition-colors duration-500 hover:border-alta ${c.accent ? "bg-ink text-paper border-ink" : "bg-paper border-ink/10"}`}
          >
            <p className={`font-serif text-4xl font-light ${c.accent ? "text-alta" : "text-ink"}`}>{c.value ?? "—"}</p>
            <p className={`mt-2 text-[10px] tracking-[0.2em] uppercase ${c.accent ? "text-paper/60" : "text-ink/50"}`}>{c.label}</p>
          </Link>
        ))}
      </div>

      <div className="mt-12">
        <div className="flex items-center justify-between mb-5">
          <h2 className="font-serif text-2xl font-light text-ink">Latest Enquiries</h2>
          <Link to="/admin/enquiries" data-testid="dashboard-all-enquiries" className="text-[10px] tracking-[0.2em] uppercase text-alta">View all</Link>
        </div>
        <div className="bg-paper border border-ink/10 divide-y divide-ink/5">
          {recent.length === 0 && <p className="p-6 text-sm font-light text-ink/50" data-testid="no-enquiries">No enquiries yet.</p>}
          {recent.map((e) => (
            <div key={e.id} className="p-5 flex flex-wrap items-center gap-4 justify-between" data-testid={`recent-enquiry-${e.id}`}>
              <div>
                <p className="font-medium text-ink text-sm">{e.name}</p>
                <p className="text-xs font-light text-ink/55 mt-0.5">{e.enquiry_type} · {e.email}</p>
              </div>
              <span className={`text-[10px] tracking-[0.15em] uppercase px-3 py-1.5 ${STATUS_COLORS[e.status] || STATUS_COLORS.NEW}`}>
                {e.status}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
